import { ApiController } from "@/classes/ApiController";

export const ContactMethod = {
  EMAIL: "Email",
  PHONE: "Call",
  WHATSAPP: "Whatsapp",
  LANDING: "Landing",
  INSTAGRAM: "Instagram",
  FACEBOOK: "Facebook",
};

export const ContactedType = {
  POSITIVE: "Positive",
  NEGATIVE: "Negative",
  UNDEFINED: "---",
};

export const LevelingTest = {
  POSITIVE: "Yes",
  NEGATIVE: "No",
  UNDEFINED: "---",
};

export const SchoolType = {
  LANGUAGE: "ARCHES Language",
  EDUCATIONAL: "ARCHES Educational",
};

export const contactsController = new ApiController("/api/contacts/");

export const observationsController = new ApiController("/api/contact-history/");

export const marketingSourcesController = new ApiController("/api/marketing/");

export const levels = [
  "Undefined",
  "Pre A1",
  "Pre A1+",
  "A1-",
  "A1",
  "A1+",
  "A2-",
  "A2",
  "A2+",
  "B1-",
  "B1",
  "B1+",
  "B2-",
  "B2",
  "B2+",
  "C1-",
  "C1",
];

export const HistoryType = {
  DATE: "Date",
  NOTE: "Note",
};

export const ProgramItems = [
  "Undefined",
  "1s Grp",
  "1s Ind",
  "1s Ind + 1 Grp",
  "2s Grp",
  "2s Ind",
  "2s Ind + 1 Grp",
  "3s Grp",
  "3s Ind",
  "3s Ind + 1 Grp",
  "4s Grp",
  "4s Ind",
  "4s Ind + 1 Grp",
  "5s Grp",
  "5s Ind",
];

export const StatusEnum = {
  ACTIVE: "Active",
  INACTIVE: "Inactive",
  POTENTIAL: "Potential",
};
